import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Projects from "@/components/Projects";
import GitHubSnippet from "@/components/GitHubSnippet";
import Testimonials from "@/components/Testimonials";
import ConnectSection, { Footer } from "@/components/ConnectSection";
import CustomCursor from "@/components/CustomCursor";

export default function Landing() {
  return (
    <div className="relative noise-bg">
      <CustomCursor />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Projects />
        <GitHubSnippet />
        <Testimonials />
        <ConnectSection />
      </main>
      <Footer />
    </div>
  );
}
